import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { SkuProduct, AbstractSkuService } from '@garmin-avcloud/avcloud-fly-web-common/api';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SkuService implements AbstractSkuService {
  private readonly http = inject(HttpClient);

  getSkuProducts(skus: string | string[]): Observable<SkuProduct[]> {
    return this.http.get<SkuProduct[]>(`${environment.flyLegacyUrl}/api/products/info`, {
      params: new HttpParams().append('sku', Array.isArray(skus) ? skus.join(',') : skus)
    });
  }

  skuProductsMap$(skus: string[]): Observable<Map<string, SkuProduct>> {
    if (skus.length == 0) {
      return of(new Map());
    } else {
      return this.getSkuProducts(skus).pipe(
        map((skuProducts: SkuProduct[]) => new Map(skuProducts.map((product) => [product.sku, product])))
      );
    }
  }
}
